<template>
    <Head>
        <title>search</title>
        <meta
            name="description"
            content="Search CDL Jobs | All You Need is a Zip code"
        />
        <meta
            name="keywords"
            content="Truck Driving Jobs,Truck Driving Jobs Near Me"
        />
        <meta property="og:title" content="Search" />
        <meta property="og:site_name" content="opencdljobs.com" />
        <meta
            property="og:description"
            content="Search CDL Jobs | All You Need is a Zip code"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://opencdljobs.com/" />
        <meta
            property="og:image"
            content="https://opencdljobs.com/images/opencdljobs.png"
        />
    </Head>

    <div class="bg-white">
        <div class="flex flex-1 items-center justify-center">
            <div class="relative w-full max-w-md md:max-w-4xl pt-12 xl:pt-24">
                <!-- <div
          class="invisible dark:visible absolute inset-0 bg-blue-600 rounded-md blur opacity-50"
        ></div> -->
                <div class="relative p-8 shadosw-lg rounded-md space-y-3">
                    <p class="text-gray-500 float-right text-sm tracking-wider">
                        More than
                        <strong class="text-lg italic text-blue-500">{{
                            searches
                        }}</strong>
                        searches
                    </p>
                    <div v-if="isAgent" class="pt-8">
                        <p class="mb-2">Filter By Companies</p>
                        <div
                            class="grid grid-cols-12 gap-4 border border-gray-100 shadow-sm rounded-md p-8"
                        >
                            <div
                                v-for="company in companies"
                                :key="company.id"
                                class="col-span-3"
                            >
                                <label
                                    :for="`toggle-${company.id}`"
                                    class="flex items-center cursor-pointer"
                                >
                                    <div class="relative">
                                        <input
                                            type="checkbox"
                                            :id="`toggle-${company.id}`"
                                            :value="company.id"
                                            v-model="selectedCompanies"
                                            class="sr-only"
                                        />
                                        <div
                                            class="block w-9 h-5 rounded-full"
                                            :style="{
                                                backgroundColor:
                                                    selectedCompanies.includes(
                                                        company.id
                                                    )
                                                        ? '#2563EB'
                                                        : '#D1D5DB',
                                            }"
                                        ></div>
                                        <div
                                            class="dot absolute left-1 top-1 bg-white w-3 h-3 rounded-full transition"
                                            :style="{
                                                transform:
                                                    selectedCompanies.includes(
                                                        company.id
                                                    )
                                                        ? 'translateX(1rem)'
                                                        : 'translateX(0)',
                                            }"
                                        ></div>
                                    </div>
                                    <p
                                        class="ml-3 text-gray-700"
                                        style="max-width: 200px"
                                    >
                                        {{ company.actual_name }}
                                    </p>
                                </label>
                            </div>
                        </div>
                        <div v-if="form.errors.companiesToFilter">
                            <p
                                v-if="form.errors.companiesToFilter"
                                class="pt-4 text-sm text-red-600"
                                v-text="form.errors.companiesToFilter"
                            ></p>
                        </div>
                    </div>
                    <div class="flex flex-col justify-start py-3 w-full">
                        <h1 class="text-5xl font-bold text-blue-600">
                            Search CDL Jobs
                        </h1>
                        <h1 class="text-xl font-bold text-red-500">
                            All You Need is a Zip code
                        </h1>
                    </div>

                    <form
                        v-if="isAgent"
                        @submit.prevent="searchById"
                        class="border-b pb-8 mb-8"
                    >
                        <div class="mt-4">
                            <label for="jobId" class="sr-only">Job ID</label>
                            <input
                                type="text"
                                name="jobId"
                                id="jobId"
                                class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm rounded-md"
                                :class="
                                    jobSearchForm.errors.jobId
                                        ? 'border-red-400'
                                        : 'border-gray-300'
                                "
                                placeholder="Enter the Job ID"
                                v-model="jobSearchForm.jobId"
                                required
                            />
                            <p
                                v-if="jobSearchForm.errors.jobId"
                                class="mt-1 ml-2 text-sm text-red-600"
                                v-text="jobSearchForm.errors.jobId"
                            ></p>
                            <p
                                v-if="jobSearchForm.errors.companiesToFilter"
                                class="mt-1 ml-2 text-sm text-red-600"
                                v-text="jobSearchForm.errors.companiesToFilter"
                            ></p>
                        </div>

                        <div class="mt-4">
                            <button
                                class="flex items-center justify-center w-full py-3 bg-green-600 hover:bg-green-500 text-white text-sm font-medium rounded disabled:bg-green-400 disabled:cursor-not-allowed"
                                :disabled="jobSearchForm.processing"
                            >
                                <svg
                                    v-show="jobSearchForm.processing"
                                    class="animate-spin mr-3 h-5 w-5 text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        class="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        stroke-width="4"
                                    ></circle>
                                    <path
                                        class="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    ></path>
                                </svg>
                                <span>Search</span>
                            </button>
                        </div>
                    </form>

                    <form @submit.prevent="submit">
                        <div class="space-y-7">
                            <label for="zipcode" class="sr-only"
                                >Zip Code</label
                            >
                            <input
                                type="text"
                                name="zipcode"
                                ref="zipCodeInput"
                                id="zipcode"
                                class="p-6 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm rounded-full"
                                :class="
                                    form.errors.zipcode
                                        ? 'border-red-400'
                                        : 'border-gray-300'
                                "
                                placeholder="Enter Your Zip Code"
                                v-model="form.zipcode"
                                required
                            />
                            <p
                                v-if="form.errors.zipcode"
                                class="mt-1 ml-2 text-sm text-red-600"
                                v-text="form.errors.zipcode"
                            ></p>
                        </div>

                        <div class="mt-4 py-7">
                            <div class="grid grid-cols-2 gap-4">
                                <div>
                                    <label
                                        for="cdl"
                                        class="block text-sm font-medium text-gray-400 tracking-wider ml-4 shadow-2xl"
                                        >CDL Class</label
                                    >
                                    <select
                                        id="cdl"
                                        name="cdl"
                                        class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-full"
                                        @change="
                                            form.cdl_class = $event.target.value
                                        "
                                    >
                                        <option
                                            v-for="cdl_class in cdl_classes"
                                            :key="cdl_class.value"
                                            :value="cdl_class.value"
                                            :selected="
                                                cdl_class.value ===
                                                form.cdl_class
                                            "
                                        >
                                            {{ cdl_class.label }}
                                        </option>
                                    </select>
                                </div>
                                <div>
                                    <label
                                        for="job_type"
                                        class="block text-sm font-medium text-gray-400 tracking-wider ml-4"
                                        >Job Type</label
                                    >
                                    <select
                                        id="job_type"
                                        name="job_type"
                                        class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-full"
                                        @change="
                                            form.job_type = $event.target.value
                                        "
                                    >
                                        <option
                                            :selected="form.job_type === 'all'"
                                            value="all"
                                        >
                                            All
                                        </option>
                                        <option
                                            v-for="jobType in jobTypes"
                                            :value="jobType.id"
                                            :key="`job-type-${jobType.id}`"
                                            :selected="
                                                form.job_type === jobType.id
                                            "
                                        >
                                            {{ jobType.name }}
                                        </option>
                                    </select>
                                </div>

                                <!-- <div class="relative flex items-start pt-7">
                  <div class="flex items-center h-5">
                    <input
                      id="sap"
                      type="checkbox"
                      class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                      name="sap"
                      value="1"
                      v-model="form.sap_only"
                    />
                  </div>
                  <div class="ml-3 text-sm">
                    <label
                      for="sap"
                      class="text-sm font-medium text-gray-700"
                      >SAP Jobs Only</label
                    >
                  </div>
                </div> -->
                            </div>
                        </div>

                        <div class="mt-8">
                            <button
                                class="flex items-center justify-center w-1/4 py-3 bg-blue-600 hover:bg-blue-500 text-white text-sm font-medium rounded-full disabled:bg-green-400 disabled:cursor-not-allowed"
                                :disabled="form.processing"
                            >
                                <svg
                                    v-show="form.processing"
                                    class="animate-spin mr-3 h-5 w-5 text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        class="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        stroke-width="4"
                                    ></circle>
                                    <path
                                        class="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    ></path>
                                </svg>
                                <span>Get Jobs</span>
                            </button>
                        </div>

                        <!-- <div class="mt-4 relative">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-gray-300"></div>
            </div>
            <div class="relative flex justify-center text-sm">
              <span class="px-2 bg-white text-gray-500">Or</span>
            </div>
          </div> -->

                        <!-- <div class="mt-4">
            <p class="text-center">
              <Link
                :href="route('jobs')"
                class="text-sm font-medium text-gray-700 hover:underline"
                >Browse All Jobs</Link
              >
            </p>
          </div> -->
                    </form>
                </div>
            </div>
        </div>
        <div class="py-8 lg:w-1/2 mx-auto space-y-2 px-8">
            <h1 class="font-bold lg:text-2xl text-xl">
                Welcome to
                <a href="https://opencdljobs.com/">OpenCDLJobs.com</a>
            </h1>
            <p class="text-[18px] text-justify leading-6">
                The premier destination for CDL truck drivers seeking new
                opportunities across the lower 48 states. Whether you're an
                experienced driver or just starting your career, our platform
                connects you with the best truck driving jobs nationwide. Browse
                a wide range of positions, from long-haul to local routes, and
                find your ideal fit. Our user-friendly website offers the latest
                openings in the trucking industry, ensuring you never miss out
                on high-demand CDL jobs. Join our community today and steer your
                career towards success with top employers in the transport
                sector.
            </p>
        </div>
    </div>
</template>

<script>
import { Link, Head, useForm } from "@inertiajs/inertia-vue3";
import { computed, watch, ref, onMounted } from "vue";
import debounce from "lodash/debounce";
import { RefreshIcon } from "@heroicons/vue/solid";
import AppFooter from "@/components/Layouts/Footer";
import ProfileDropdown from "@/components/ProfileDropdown";

export default {
    props: {
        companies: Array,
        jobTypes: Object,
        searchCount: Number,
        auth: Object,
    },

    setup(props) {
        const route = window.route;
        const zipCodeInput = ref(null);
        const initialCount = ref(1397);
        const selectedCompanies = ref([]);

        onMounted(() => {
            zipCodeInput.value.focus();
            selectedCompanies.value = props.companies.map(
                (company) => company.id
            );
        });

        const url = new URLSearchParams(window.location.search);

        const cdl_classes = [
            { value: "a", label: "CDL A" },
            { value: "b", label: "CDL B" },
        ];

        const form = useForm({
            zipcode: "",
            cdl_class: "a",
            job_type: "all",
            companiesToFilter: selectedCompanies,
            // owner_operator: false,
            sap_only: url.get("sap_only") == 1,
            filter_option: url.get("filter_option") || "open",
        });

        const jobSearchForm = useForm({
            jobId: "",
        });

        const searches = computed(
            () => parseInt(props.searchCount) + initialCount.value
        );

        const zipcode = computed(() => form.zipcode);

        const isAgent = computed(
            () =>
                props.auth &&
                (props.auth.role.includes("agent") ||
                    props.auth.role.includes(
                        "Restricted Agent to companies US Xpress, Heartland and DB Schenker"
                    ))
        );

        watch(
            zipcode,
            debounce(
                (val) => {
                    if (form.errors.zipcode) {
                        form.clearErrors("zipcode");
                    }
                },
                250,
                true
            )
        );

        function submit() {
            form.post("/search");
        }

        function searchById() {
            jobSearchForm.post(route("jobs.search-by-id"));
        }

        return {
            form,
            route,
            submit,
            isAgent,
            searchById,
            cdl_classes,
            jobSearchForm,
            zipCodeInput,
            selectedCompanies,
            searches,
        };
    },

    components: {
        Head,
        AppFooter,
        RefreshIcon,
        Link,
        ProfileDropdown,
    },
};
</script>
<style scoped>
/* Toggle dot transition */
.dot {
    transition: transform 0.2s ease-in-out;
}
</style>
